import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import { Alert } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    try {
      const result = await api.post<{ message: string }>('/api/account/request-password-reset', {
        email,
      });
      setMessage(result.message);
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'No se pudo enviar el enlace');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Recuperar contraseña</h1>
        <p className="muted">Te enviaremos un enlace si el email existe en nuestra base de datos.</p>
        {message ? (
          <div style={{ marginTop: '1rem' }}>
            <Alert tone="success">{message}</Alert>
          </div>
        ) : null}
        <form method="post" action="/recuperar-contrasena" autoComplete="on" onSubmit={handleSubmit}>
          <Input
            label="Email"
            id="username"
            name="username"
            type="email"
            inputMode="email"
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" loading={loading}>
            Enviar enlace
          </Button>
        </form>
        <p className="auth-card__footer">
          <Link to="/login">Volver al login</Link>
        </p>
      </div>
    </div>
  );
}
